import { Button } from '@material-ui/core';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import HeaderPage from '~/components/HeaderPage';
import { api } from '~/services/api';
import { ApplicationState } from '~/store';
import {
  areasRequest,
  changeInsert,
  tratamentoAtividadesRequest,
} from '~/store/ducks/ManterAtividadesTratamentoDados/actions';
import { Container, StyledButton } from './styles';
import Table from './Table';

const ManterAtividadesTratamentoDados: React.FC = () => {
  const dispatch = useDispatch();

  const manterAtividadesTratamento = useSelector<ApplicationState, any>(
    state => state.ManterAtividadesTratamentoDados,
  );

  const { company, token } = useSelector<ApplicationState, any>(
    state => state.auth,
  );

  useEffect(() => {
    dispatch(tratamentoAtividadesRequest(0, 5));
    dispatch(areasRequest(company?.country_company_id));
  }, [company, dispatch]);

  const transformArea = useCallback(
    (row: any) => {
      const index = manterAtividadesTratamento.areas?.findIndex(
        (el: any) => el.company_area_id === row.company_area_id,
      );

      if (index !== -1) {
        return manterAtividadesTratamento.areas[index].company_area_ds;
      }
    },
    [manterAtividadesTratamento.areas],
  );

  const generatePdf = useCallback(async () => {
    try {
      const response = await api.get(
        `/v1/atividades?pageNo=${0}&pageSize=${
          manterAtividadesTratamento.data.tratamentoAtividades[0].total_itens
        }`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            company: company?.country_company_id,
          },
        },
      );

      const categorias = await api.get(`/v1/categories`, {
        headers: {
          'content-type': 'application/json',
          company: company?.country_company_id,
        },
      });

      const body = response.data.map((el: any) => {
        const titularesSemvirgula = el?.atividade_titular.map((at: any) => {
          const index = categorias.data?.findIndex(
            (cat: any) => cat.data_holder_cat_id === at.data_holder_cat_id,
          );

          return `${categorias.data[index].data_holder_cat_name}`;
        });

        return [
          el.status_fl === 'Y' ? 'Ativado' : 'Desativado',
          `${company?.company?.company_name}-${company?.country?.country_name}`,
          el.data_operation_id,
          transformArea(el),
          el.data_treat_operation_nm,
          el.responsable_nm,
          el.responsable_contact_ds,
          titularesSemvirgula.join(),
          el.consent_type_fl === 'Y' ? 'Automático' : 'Manual',
        ];
      });

      const doc = new jsPDF();

      //@ts-ignore
      doc.autoTable({
        headStyles: {
          fontSize: 7,
          textColor: '#fff',
          fillColor: '#282c34',
        },
        bodyStyles: {
          fontSize: 7,
        },
        margin: { top: 8, left: 8, right: 8, bottom: 8 },
        head: [
          [
            'Situação',
            'Empresa',
            'Código da atividade',
            'Área',
            'Atividade de tratamento de dados',
            'Pessoa responsável',
            'Contato da pessoa responsável',
            'Tipo de titular de dados',
            'Tipo de consentimento',
          ],
        ],
        body: [...body],
      });

      doc.save('manter_atividades_de_tratamento_de_dados.pdf');
    } catch (error) {
      toast.error(error.message);
    }
  }, [
    company,
    manterAtividadesTratamento.data.tratamentoAtividades,
    token,
    transformArea,
  ]);

  return (
    <Container>
      <HeaderPage pageTitle="Manter atividades de tratamento de dados" />

      <div className="main-content-solicitar-ajuda-dpo">
        <h1 className="titululo-atividades">Consultar atividades</h1>
        <Table
          ResetPage={manterAtividadesTratamento.resetPage}
          className="table-lgpd"
          getOrderHandleChangePage={(value: number, rowsPerPage: number) =>
            dispatch(tratamentoAtividadesRequest(value, 5))
          }
          data={manterAtividadesTratamento.data.tratamentoAtividades}
        />

        <div className="buttonGroup">
          <Button
            data-toggle="modal"
            data-target="#exampleModal"
            variant="outlined"
            className="button-continue ajuda"
            onClick={() => dispatch(changeInsert('insert'))}
          >
            Incluir atividades
          </Button>

          <StyledButton className="button-continue" onClick={generatePdf}>
            Exportar
          </StyledButton>
        </div>
      </div>
    </Container>
  );
};

export default ManterAtividadesTratamentoDados;
